const data = [
    {
        "评审姓名": "徐毅",
        "介绍": "评审委员会主席",
        "角色": "Timothy Xu",
        "组": "主席",
        "url": "http://img01.cmicawards.org.cn/cover/评委_徐毅.jpg"
    },
    {
        "评审姓名": "李宗盛",
        "介绍": "评审团首席顾问",
        "角色": "Jonathan Lee",
        "组": "首席顾问",
        "url": "http://img01.cmicawards.org.cn/cover/评委_李宗盛.jpg"
    },
    {
        "评审姓名": "金少刚",
        "介绍": "著名录音混音及现场演出录音工程师、金总文工团舞美制作中心副主任、北京奥运会开幕式的音响总工程师、浙江卫视《中国好声音》音响总监",
        "角色": "评审",
        "组": "金少刚",
        "url": "http://img01.cmicawards.org.cn/cover/评委_金少刚.jpg",
        "组员": [
            {
                "评审姓名": "陈珞",
                "介绍": "著名录音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "李军",
                "介绍": "华语金曲奖最佳录音师\n",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "瞿然",
                "介绍": "著名录音师、混音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "时俊峰",
                "介绍": "著名录音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "王磊",
                "介绍": "高级录音师、混音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "张博",
                "介绍": "著名录音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "张军军",
                "介绍": "录音师、调音师、制作人",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "章寅",
                "介绍": "录音师",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "赵靖",
                "介绍": "北京BIG.J Studio创始人，录音师混音师\n",
                "角色": "顾问",
                "组": "金少刚"
            },
            {
                "评审姓名": "周天澈",
                "介绍": "著名录音师",
                "角色": "顾问",
                "组": "金少刚"
            }
        ]
    },
    {
        "评审姓名": "沈黎晖",
        "介绍": "摩登天空创始人、草莓音乐节创始人、音乐人",
        "角色": "评审",
        "组": "沈黎晖",
        "url": "http://img01.cmicawards.org.cn/cover/评委_沈黎晖.jpg",
        "组员": [
            {
                "评审姓名": "周小川",
                "介绍": "星外星音乐总裁",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "丁武",
                "介绍": "歌手、画家",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "李岱",
                "介绍": "热波传媒总裁",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "臧鸿飞",
                "介绍": "摇滚、电子、流行、爵士等多种风格的音乐家兼制作人",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "郝舫",
                "介绍": "著名作家、乐评人、文化名人、电视节目制片人、菠萝BOLO CEO",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "李宏杰",
                "介绍": "MTA天漠音乐节创始人、张北音乐节创办人",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "袁涛",
                "介绍": "心喜文化创始人CEO",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "张有待",
                "介绍": "主持人、最具影响力的中国DJ ",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "陈健添",
                "介绍": "乐坛传奇伯乐、现任摇滚优先厂牌老板",
                "角色": "顾问",
                "组": "沈黎晖"
            },
            {
                "评审姓名": "杨锦聪",
                "介绍": "独立制片唱片公司“风潮有声出版有限公司”创办人、总经理",
                "角色": "顾问",
                "组": "沈黎晖"
            }
        ]
    },
    {
        "评审姓名": "金培达",
        "介绍": "资深作曲、监制、电影音乐人",
        "角色": "评审",
        "组": "金培达",
        "url": "http://img01.cmicawards.org.cn/cover/评委_金培达.jpg",
        "组员": [
            {
                "评审姓名": "陈少琪",
                "介绍": "资深作词人及创作人，香港作曲家及作词家协会理事",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "舒文",
                "介绍": "流行⾳乐专业监制、作曲、编曲及录⾳室创办⼈。",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "陈辉阳",
                "介绍": "著名音乐监制及作曲家",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "Ted Lo",
                "介绍": "著名爵士乐手，作曲、编曲及监制",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "李念和",
                "介绍": "资深制作人及词曲创作者，\n中华音乐著作权协会 MÜST董事长 \n巨室音乐副总经理及音乐总监",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "方文山",
                "介绍": "著名词作家",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "科以泌夫",
                "介绍": "著名词曲创作人 、乐评人  \n各大歌坛颁奖及选秀比赛资深评委  \n中国流行音乐学会理事 ",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "崔恕",
                "介绍": "著名作词人",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "老狼",
                "介绍": "校园民谣代表人物，现活跃于各大音乐节和其他现场音乐演出项目。",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "张靓颖",
                "介绍": "著名歌手",
                "角色": "顾问",
                "组": "金培达"
            },
            {
                "评审姓名": "萧敬腾",
                "介绍": "著名歌手",
                "角色": "顾问",
                "组": "金培达"
            }
        ]
    },
    {
        "评审姓名": "贾敏恕",
        "介绍": "街声股份有限公司总裁、简单生活节共同创办人",
        "角色": "评审",
        "组": "贾敏恕",
        "url": "http://img01.cmicawards.org.cn/cover/评委_贾敏恕.jpg",
        "组员": [
            {
                "评审姓名": "李皖",
                "介绍": "文化人，资深乐评",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "王昕",
                "介绍": "文化人，资深乐评",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "郝舫",
                "介绍": "文化人，资深乐评",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "张帆",
                "介绍": "原创音乐推动者、迷笛创办人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "安栋",
                "介绍": "资深制作人、编曲家",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "钟兴民",
                "介绍": "资深制作人、编曲家",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "马正远",
                "介绍": "潮流音乐推动者，88上昇创办人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "姚中仁",
                "介绍": "嘻哈音乐先锋",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "张楚",
                "介绍": "词曲作家、资深原创音乐人",
                "角色": "顾问",
                "组": "贾敏恕"
            },
            {
                "评审姓名": "高旗",
                "介绍": "词曲作家、资深原创音乐人",
                "角色": "顾问",
                "组": "贾敏恕"
            }
        ]
    },
    {
        "评审姓名": "宋晓辉",
        "介绍": "资深唱片设计师、摄影师，长期从事音乐视觉工作",
        "角色": "评审",
        "组": "宋晓辉",
        "url": "http://img01.cmicawards.org.cn/cover/评委_宋晓辉.jpg",
        "组员": [
            {
                "评审姓名": "秦四风",
                "介绍": "音乐家、制作人、导演",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "朱桦",
                "介绍": "歌手、音乐类节目资深评委",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "唐大年",
                "介绍": "著名编剧、导演",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "尤洋",
                "介绍": "UCCA尤伦斯当代艺术中心副馆长，艺术评论家",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "倪兵",
                "介绍": "资深DJ、音乐文化交流使者，独立音乐厂牌创办人",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "健崔",
                "介绍": "艺术家、策展人，文化活动家",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "詹盼",
                "介绍": "音乐人、唱片设计师",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "赵宏韬",
                "介绍": "新锐唱片设计师",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "颜伯骏",
                "介绍": "台湾唱片设计师",
                "角色": "顾问",
                "组": "宋晓辉"
            },
            {
                "评审姓名": "何明圣",
                "介绍": "导演",
                "角色": "顾问",
                "组": "宋晓辉"
            }
        ]
    },
    {
        "评审姓名": "谭伊哲",
        "介绍": "全能型音乐家、音乐总监、编曲家、著名音乐制作人、作曲家、集合多种乐器演奏于一身、被誉为华语歌坛“音乐魔法师”",
        "角色": "评审",
        "组": "谭伊哲",
        "url": "http://img01.cmicawards.org.cn/cover/评委_谭伊哲.jpg",
        "组员": [
            {
                "评审姓名": "李伟菘",
                "介绍": "新加坡著名音乐创作人、制作人",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "李偲菘",
                "介绍": "新加坡著名音乐创作人、制作人",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "凃惠源",
                "介绍": "台湾著名作曲家、编曲家、音乐制作人。台湾“金曲奖”评审团评审之一。\n",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "王治平",
                "介绍": "台湾知名音乐制作人。\n",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "曹轩宾",
                "介绍": "华语流行歌手，著名创作人、音乐制作人。\n",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "NG Ken Luke, Dharni Soonanng（达尼）",
                "介绍": "2013、2014年GBBB世界bbox挑战赛冠军",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "曲世聪",
                "介绍": "著名音乐制作人，先锋乐派音乐鬼才。",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "赵兆",
                "介绍": "中国音乐制作人,音乐总监和台湾金曲奖最佳编曲奖得主",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "陈迪",
                "介绍": "内地年轻全能音乐制作人、音乐总监，中国首届“全国编曲之王挑战赛”冠军。80后杰出音乐人才代表。\n",
                "角色": "顾问",
                "组": "谭伊哲"
            },
            {
                "评审姓名": "郑伟",
                "介绍": "中国内地著名编曲、音乐制作人、音乐总监。",
                "角色": "顾问",
                "组": "谭伊哲"
            }
        ]
    },
    {
        "评审姓名": "老锣",
        "介绍": "中国新艺术音乐的作曲家、创立者",
        "角色": "评审",
        "组": "老锣",
        "url": "http://img01.cmicawards.org.cn/cover/评委_老锣.jpg",
        "组员": [
            {
                "评审姓名": "邹文琴 ",
                "介绍": "著名声乐教育家",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "夏可君",
                "介绍": "哲学家、艺术批评家与著名策展人",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "赵仲明",
                "介绍": "音乐学博士，国内多所音乐学院特聘教授。国家“十三五”重点出版物评审专家、国家新闻出版广电总局进口音像审查委员会审查专家、中国出版集团现代出版社特聘音乐总监。音乐学术类人气公众号《国音爱乐》创始人。",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "王华",
                "介绍": "笛子演奏家，中国音乐学院副教授，中国音乐家协会会员，中国音乐家协会竹笛学会秘书长",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "冀翔",
                "介绍": "录音博士、听觉艺术博士",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "刘雪枫",
                "介绍": "音乐评论家",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "杜亚雄",
                "介绍": "世界音乐教授、中国音乐学院教授，浙江音乐学院特聘教授",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "张小群",
                "介绍": "北京舞蹈学院音乐剧系主任，音乐剧学科带头人、研究生导师。九三学社社员。中国音乐剧协会理事；中国音乐家协会会员。\n",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "柯军",
                "介绍": "昆曲表演艺术家、国家一级演员、江苏省戏剧家协会主席、江苏省演艺集团艺术总监",
                "角色": "顾问",
                "组": "老锣"
            },
            {
                "评审姓名": "程艳丽 ",
                "介绍": "民间艺术家，把唢呐和西方乐器小融合，让单一的表演变成了多样化表演。",
                "角色": "顾问",
                "组": "老锣"
            }
        ]
    },
    {
        "评审姓名": "任宇清",
        "介绍": "爵士中国推行者，JZ MUSIC 创始人CEO，贝司演奏家",
        "角色": "评审",
        "组": "任宇清",
        "url": "http://img01.cmicawards.org.cn/cover/评委_任宇清.jpg",
        "组员": [
            {
                "评审姓名": "刘元",
                "介绍": "萨克斯演奏家，中国爵士乐领军人物",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "有待",
                "介绍": "中国著名DJ、电台主播，摇滚乐、爵士乐、电子乐的传播者",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "Laura Fygi",
                "介绍": "她是是第一位打入美国告示排杂志爵士乐排行榜的荷兰歌手，媒体因为她低沉如丝质般细致的磁性音质称她为“丝绒歌喉”。",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "包以正",
                "介绍": "香港爵士乐坛的前锋",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": " Jeremy Monteiro ",
                "介绍": "钢琴家，作曲家，爵士乐教育家",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "Carlo Pagnotta",
                "介绍": "世界知名爵士音乐节——意大利翁布里亚爵士节创始人兼艺术总监",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "梁和平",
                "介绍": "音乐先行者、实践者、宣导者及推动者",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "沈鸿元",
                "介绍": "音乐文字工作者，台北爱乐电台FM99.7「爵士夜」节目主持兼制作人，曾任「台中爵士音乐节」音乐总监。",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "Antonio Hart",
                "介绍": "知名萨克斯演奏家、爵士乐教育家",
                "角色": "顾问",
                "组": "任宇清"
            },
            {
                "评审姓名": "彭飞",
                "介绍": "音乐制作人、作曲家、编曲家、爵士小提琴演奏家。金曲奖演奏类最佳作曲人奖获奖者",
                "角色": "顾问",
                "组": "任宇清"
            }
        ]
    },
    {
        "评审姓名": "李飙",
        "介绍": "柏林国立汉斯-艾斯勒音乐学院终身教授，北京中央音乐学院教授，国际著名打击乐演奏家，指挥家",
        "角色": "评审",
        "组": "李飙",
        "url": "http://img01.cmicawards.org.cn/cover/评委_李飙.jpg",
        "组员": [
            {
                "评审姓名": "梁大南",
                "介绍": "著名小提琴演奏家，中央音乐学院教授",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "朱亦兵",
                "介绍": "著名大提琴演奏家，中央音乐学院教授",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "林朝阳",
                "介绍": "著名小提琴演奏家，中央音乐学院教授",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "李岚松",
                "介绍": "著名大管演奏家，中央音乐学院教授",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "杨力",
                "介绍": "著名指挥家，中央音乐学院教授",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "崔鸿根",
                "介绍": "著名钢琴演奏家，中央音乐学院教授",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "Jakob haendel ",
                "介绍": "著名瑞典录音师，九次格莱美获奖",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "王纪宴",
                "介绍": "古典乐评人，中国艺术研究院研究员",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "李喆",
                "介绍": "国家大剧院乐团首席",
                "角色": "顾问",
                "组": "李飙"
            },
            {
                "评审姓名": "袁芳",
                "介绍": "著名钢琴家",
                "角色": "顾问",
                "组": "李飙"
            }
        ]
    }
]

export default data